export default "__VITE_ASSET__B3VFgd_5__"